import type { LngLatBoundsLike } from "react-map-gl/maplibre";

export const switzerlandBounds = [
  [5.959163533, 45.816873409],
  [10.573855918, 47.763295087],
] satisfies LngLatBoundsLike;

export const switzerlandBoundsWithPadding = [
  switzerlandBounds[0][0] - 2,
  switzerlandBounds[0][1] - 1,
  switzerlandBounds[1][0] + 2,
  switzerlandBounds[1][1] + 1,
] as const;

export type WGS84Coordinates = {
  latitude: number;
  longitude: number;
};

export type LV95Coordinates = `${number}/${number}`;

export const switzerlandCenter = {
  longitude: 8.225456721,
  latitude: 46.858428798,
};

export function swisstopoUrl(lv03Coordinates: string | undefined | null, lang = "de") {
  if (!lv03Coordinates) return;

  const coordinates = lv03Coordinates.replace(/\s/g, "").split("/").join(",");
  const queryParams = new URLSearchParams({
    lang: lang,
    center: coordinates,
    z: "8",
    bgLayer: "ch.swisstopo.pixelkarte-farbe",
    crosshair: `marker,${coordinates}`,
  });
  return `https://map.geo.admin.ch/#/map?${queryParams.toString()}`;
}
